import IDS from '../../../constants/IDS';
import MESSAGE_TYPES from '../../../constants/MESSAGE_TYPES';
import { isMobile } from '../../../helpers/device';
import transliterate from '../../../helpers/transliterate';
import { AppSettings } from '../../../types/settings';

class AppSkeleton {
  params: AppSettings;

  constructor(props) {
    this.params = props;

    this.handleMessageReceive = this.handleMessageReceive.bind(this);

    const root = document.getElementById(IDS.root);

    if (!root) {
      window.addEventListener('message', this.handleMessageReceive, false);
    }
  }

  unmount() {
    window.removeEventListener('message', this.handleMessageReceive);
  }

  handleMessageReceive(event) {
    const message = event.message ? 'message' : 'data';

    switch (event[message].type) {
      case MESSAGE_TYPES.FULLSCREEN: {
        const { isFullscreen } = event[message];
        const { onChangeFullscreen } = this.params;

        if (onChangeFullscreen) {
          onChangeFullscreen(isFullscreen);
        }

        if (isMobile()) {
          isFullscreen ? this.hideMobileOverlay() : this.showMobileOverlay();
        }
        break;
      }
      case MESSAGE_TYPES.ADD_TICKET: {
        const { ticket } = event[message];
        const { onAddTicket } = this.params;

        if (onAddTicket) onAddTicket(ticket);
        break;
      }
      case MESSAGE_TYPES.DELETE_TICKET: {
        const { ticket } = event[message];
        const { onDeleteTicket } = this.params;

        if (onDeleteTicket) onDeleteTicket(ticket);
        break;
      }
      case MESSAGE_TYPES.SUBMIT_ORDER_FORM: {
        const { values } = event[message];
        const { onSubmitOrderForm } = this.params;

        if (onSubmitOrderForm) onSubmitOrderForm(values);
        break;
      }
      case MESSAGE_TYPES.ON_CHANGE_DATE: {
        const { date } = event[message];
        const { onChangeDate } = this.params;

        if (onChangeDate) onChangeDate(date);
        break;
      }
      case MESSAGE_TYPES.CHANGE_SCHEME_MODE: {
        const { isScheme } = event[message];

        const { onChangeSchemeMode } = this.params;

        if (onChangeSchemeMode) {
          onChangeSchemeMode(isScheme);
        }
        break;
      }

      case MESSAGE_TYPES.ON_TABLE_SECTOR_SELECTED: {
        const { onTableSectorSelected } = this.params;
        if (onTableSectorSelected) onTableSectorSelected(transliterate(event.data.sector));
        break;
      }

      case MESSAGE_TYPES.ON_SHOW_ORDER_FORM: {
        const { showForm } = event[message];
        const { onShowOrderForm } = this.params;
        if (onShowOrderForm) onShowOrderForm(showForm);
        break;
      }

      case MESSAGE_TYPES.ON_UNSUPPORTED_CURRENCY: {
        const { onUnsupportedCurrency } = this.params;
        if (onUnsupportedCurrency) onUnsupportedCurrency();
        break;
      }

      case MESSAGE_TYPES.CHANGE_HELP_STATE: {
        const { onChangeHelp } = this.params;
        const { isOpen } = event[message];
        if (onChangeHelp) onChangeHelp(isOpen);
        break;
      }

      case MESSAGE_TYPES.ORDER_FORM_CHANGED: {
        const { onChangeOrderForm } = this.params;
        const { values } = event[message];
        if (onChangeOrderForm) onChangeOrderForm(values);
        break;
      }

      case MESSAGE_TYPES.ORDER_FORM_INPUT_BLURED: {
        const { onBlurInputOrderForm } = this.params;
        const {
          values: { name, value },
        } = event[message];
        if (onBlurInputOrderForm) onBlurInputOrderForm(name, value);
        break;
      }

      case MESSAGE_TYPES.ON_ADD_ANNOUNCEMENT: {
        const { onAddAnnouncement } = this.params;
        const { announcement, count } = event[message];
        if (onAddAnnouncement) onAddAnnouncement(announcement, count);
        break;
      }
      case MESSAGE_TYPES.ON_DELETE_ANNOUNCEMENT: {
        const { onDeleteAnnouncement } = this.params;
        const { announcement, count } = event[message];
        if (onDeleteAnnouncement) onDeleteAnnouncement(announcement, count);
        break;
      }

      case MESSAGE_TYPES.ON_ADD_STANDING_TICKETS: {
        const { onAddStandingTickets } = this.params;
        const { standingTicket, count } = event[message];
        if (onAddStandingTickets) onAddStandingTickets(standingTicket, count);
        break;
      }
      case MESSAGE_TYPES.ON_DELETE_STANDING_TICKETS: {
        const { onDeleteStandingTickets } = this.params;
        const { standingTicket, count } = event[message];
        if (onDeleteStandingTickets) onDeleteStandingTickets(standingTicket, count);
        break;
      }

      default:
        break;
    }
  }

  hideMobileOverlay = () => {
    window.postMessage({ type: MESSAGE_TYPES.HIDE_MOBILE_OVERLAY }, '*');
  };

  showMobileOverlay = () => {
    window.postMessage({ type: MESSAGE_TYPES.SHOW_MOBILE_OVERLAY }, '*');
  };

  setSelectedDate(date) {
    window.postMessage({ type: MESSAGE_TYPES.SET_SELECTED_DATE, date }, '*');
  }

  setSelectedTickets(tickets) {
    window.postMessage({ type: MESSAGE_TYPES.SET_SELECTED_TICKETS, tickets }, '*');
  }

  unselectTickets() {
    window.postMessage({ type: MESSAGE_TYPES.UNSELECT_TICKETS }, '*');
  }

  unselectTicketIds(tickets) {
    window.postMessage({ type: MESSAGE_TYPES.UNSELECT_TICKET, tickets }, '*');
  }

  deleteMarketplaceTicket(id) {
    window.postMessage({ type: MESSAGE_TYPES.DELETE_MARKETPLACE_TICKET, id }, '*');
  }

  updateMarketplaceTicket(ticketData) {
    window.postMessage({ type: MESSAGE_TYPES.UPDATE_MARKETPLACE_TICKET, ticketData }, '*');
  }

  showOrderSuccessModal() {
    window.postMessage({ type: MESSAGE_TYPES.SHOW_ORDER_SUCCESS }, '*');
  }
}

export default AppSkeleton;
